import { useEffect, useMemo } from 'react';
import { useEventCallback } from '@mui/material';
import { type UseMutationResult } from '@tanstack/react-query';

interface UseMutationMonitoringParams {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mutations: UseMutationResult<any, any, any>[];
  onStart?: () => void;
  onSuccess?: () => void;
  onError?: () => void;
}
export function useAllMutations(params: UseMutationMonitoringParams) {
  const { mutations, onStart, onSuccess, onError } = params;

  const { isPending, isSuccess, isError } = useMemo(
    () => ({
      isPending: mutations.some((query) => query.isPending),
      isSuccess: mutations.every((query) => query.isSuccess),
      isError: mutations.some((query) => query.isError),
    }),
    [mutations],
  );

  const handleStart = useEventCallback(() => onStart?.());
  const handleSuccess = useEventCallback(() => onSuccess?.());
  const handleError = useEventCallback(() => onError?.());

  useEffect(() => {
    if (isPending) handleStart();
    if (isSuccess) handleSuccess();
    if (isError) handleError();
  }, [isPending, isSuccess, isError, handleStart, handleSuccess, handleError]);
}
